<div class="gutter">
<header #header class="flx-col flx-gap-default">
		<h1 #headerTitle *ngIf="pageTitle">{{ pageTitle }}</h1>
</header>


<div class="flx-row flx-wrap-grid flx-wrap-grid-2-xs flx-wrap-grid-3-sm flx-wrap-grid-3-md">
	<div *ngFor="let generic of generics; let i = index" >
		<div class="generic flx-col hoverable">
			<a class="generic-img-wrap" [routerLink]="['/'+path_details, generic.path]">
				<div class="badges">
					<span class="badge">{{ generic.date_publish | date:'mediumDate' }}</span>
				</div>
				<app-image *ngIf="generic.photos.length" [natural]="false" [url]="cdn+'/generics/'+generic.photos_directory+'/medium_'+generic.photos[0].filename"></app-image>
			</a>
			<a [routerLink]="['/'+path_details, generic.path]" class="generic-content flx-col flx-btwn-strtch">
				<h3>{{ generic.name }}</h3>
				<p>{{ generic.field_1 }}</p>
				<span><svg class="icon icon-arrow-narrow-right"><use xlink:href="#icon-arrow-narrow-right"></use></svg></span>
			</a>
		</div>		
	</div>
</div>

<mat-paginator #paginator
				[hidePageSize]="true"
				[length]="count"
				[pageIndex]="(query['page'] - 1)"
				[pageSize]="query['pageSize']"
				[pageSizeOptions]="[12, 24, 48]"
				(page)="onPage($event)">
</mat-paginator>

</div>
